import { Component, effect, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppNativeService } from 'src/app/services/app.native.service';
import { MainStateService } from 'src/app/services/state/app-main-state.service';
import { Browser } from '@capacitor/browser';
import { _ } from '../../consts';
import { PlatformType } from 'common_library';

@Component({
    selector: 'app-update-screen',
    templateUrl: './update-screen.component.html',
    styleUrls: ['./update-screen.component.scss'],
    standalone: false
})
export class UpdateScreenComponent {
  $show = signal<boolean>(false);
  $showAutomaticUpdateButton = signal<boolean>(true);

  constructor(
    private mainStateService: MainStateService,
    private appNativeService: AppNativeService,
    public translate: TranslateService
  ) {
    effect(async () => {
      let mustUpdate = false;
      let version = this.mainStateService.$version();
      let native = this.mainStateService.getNative();      
      if (native && version) {
        // in teoria la devo leggere dalla versione dello store, ma se per qualche motivo non ci riesco
        // prendo la versione scritta nell'ENV (che dovrebbe essere coerente)
        let appVersion = _.VERSION;
        try {
          appVersion = await this.appNativeService.getCurrentAppVersionName();
        } catch (ex) {
          this.$showAutomaticUpdateButton.set(false);
        }

        mustUpdate = this.compareAppVersions(appVersion, version.minSupportedFeVersion) < 0;
      }

      this.$show.set(mustUpdate);
    }, { allowSignalWrites: true });
  }

  private compareAppVersions(appVersion: string, requiredVersion: string): number {
    const current = this.toComparableVersionParts(appVersion);
    const required = this.toComparableVersionParts(requiredVersion);
    const length = Math.max(current.length, required.length);

    for (let i = 0; i < length; i++) {
      const currentPart = current[i] ?? 0;
      const requiredPart = required[i] ?? 0;

      if (currentPart !== requiredPart) {
        return currentPart > requiredPart ? 1 : -1;
      }
    }

    return 0;
  }

  private toComparableVersionParts(version: string): number[] {
    const parts = version
      .split('.')
      .map((part) => part.replace(/\D/g, ''))
      .map((part, index) => index === 1 ? part.padEnd(3, '0') : part)
      .map((part) => Number.parseInt(part || '0', 10));

    return parts.length ? parts : [0];
  }

  async updateApplication() {
    await this.appNativeService.startUpdate();
  }

  async openStoreLink() {
    let storeLink = '';
    if (this.mainStateService.getPlatformType() === PlatformType.AndroidNative) {
      storeLink = this.mainStateService.getVersion().playStoreLink;
    } else {
      storeLink = this.mainStateService.getVersion().appleStoreLink;
    }
    await Browser.open({ url: storeLink });
  }
}
